// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3wdWS","content":"styles_content__3apPM","checkbox":"styles_checkbox__4_15x","checkboxLabel":"styles_checkboxLabel__1P1o9"};